import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/templates/calculations");

export const getIdPath = returnPath("/templates/calculations/:id");
